/**
 * <multi-add-cart-button 
  data-products='[
    {"variantId": "123456789", "quantity": 2},
    {"variantId": "987654321", "quantity": 1},
    {"variantId": "112233445", "quantity": 3}
  ]'
>
  批量添加选中产品
</multi-add-cart-button>
 */
if (!customElements.get("multi-add-cart-button")) {
  class MultiAddCartButton extends HTMLElement {
    _shopifyFeaturesScript = document.querySelector('script[id="shopify-features"]');
    _shopifyFeatures = this._shopifyFeaturesScript ? JSON.parse(this._shopifyFeaturesScript.innerHTML) : {};
    
    // 请求头配置
    _headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': this._shopifyFeatures.accessToken 
        ? 'Basic ' + btoa(this._shopifyFeatures.accessToken) 
        : ''
    };

    // 获取产品数据属性
    get _products() {
      const productsData = this.getAttribute('data-products');
      if (!productsData) return [];
      
      try {
        return JSON.parse(productsData);
      } catch (e) {
        console.error('产品数据格式错误:', e);
        return [];
      }
    }

    constructor() {
      super();
      // 保存绑定的方法引用，确保 add/remove 使用同一引用
      this._boundAddToCart = this.addMultipleToCart.bind(this);
    }
    get _type() {
      return this.getAttribute('data-type') || ''; 
    }
    connectedCallback() {
      this.removeEventListener('click', this._boundAddToCart);
      this.addEventListener('click', this._boundAddToCart);
    }

    async addMultipleToCart() {
      const products = this._products;
      
      if (!products.length) {
        alert("Please select the product first")
        console.warn('没有要添加的产品');
        return;
      }
      const items = products.map(product => ({
        id: parseInt(product.variantId, 10),
        quantity: Math.max(1, parseInt(product.quantity || 1, 10)) 
      })).filter(item => !isNaN(item.id)); 

      if (!items.length) {
        console.error('没有有效的产品变体ID');
        return;
      }

      try {
        const response = await fetch('/cart/add.json', {
          method: 'POST',
          headers: this._headers,
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || `加购失败 (${response.status})`);
        }

        // 先获取最新购物车数据并让 theme 的赠品逻辑处理（若已定义），
        // 等待完成后再刷新抽屉内容并打开抽屉，保证首次打开就能看到赠品
        try {
          let cart = null;
          try {
            cart = await fetch('/cart.js').then(r => r.ok ? r.json() : null).catch(() => null);
          } catch (e) {
            cart = null;
          }

          if (cart && window && typeof window.updateStepCartGift === 'function') {
            try {
              await window.updateStepCartGift(cart);
            } catch (e) {
              console.error('处理阶梯赠品时出错:', e);
            }
          }

          // 刷新抽屉显示：优先使用 ajaxCart.load，否则回退到内部 updateCartUI
          if (window && typeof window.ajaxCart !== 'undefined' && typeof window.ajaxCart.load === 'function') {
            try {
              window.ajaxCart.load();
            } catch (e) {
              console.error('调用 ajaxCart.load 失败，回退到 updateCartUI:', e);
              await this.updateCartUI();
            }
          } else {
            await this.updateCartUI();
          }
        } catch (e) {
          console.error('处理加购后赠品/刷新抽屉时出错:', e);
          // 即使出错，仍尝试打开抽屉或跳转
        }

        if (this._type !== 'checkout') {
          document.querySelector('.js-drawer-open-button-right')?.click();
        } else {
          window.location.href = '/checkout';
        }
        
      } catch (error) {
        console.error('加购错误:', error);
         alert(`error: ${error.message}`);
      }
    }

    /**
     * 更新购物车UI显示
     */
    
    async updateCartUI() {
     try {
      const cartDrawerResponse = await fetch(`/cart?section_id=cart-drawer`); 
      if (cartDrawerResponse.ok) {
        const html = new DOMParser().parseFromString(
          await cartDrawerResponse.text(),
          "text/html"
        );

        const targetDrawer = document.querySelector("cart-drawer");
        const sourceDrawer = html.querySelector("cart-drawer");

        if (targetDrawer && sourceDrawer) {
          targetDrawer.innerHTML = sourceDrawer.innerHTML;
          targetDrawer.classList.add("active");
          targetDrawer.classList.remove("is-empty");
          document.body.classList.add("overflow-hidden");
        }
      }

      const cartDataResponse = await fetch(`/cart.js`); 
      if (cartDataResponse.ok) {
        const cartData = await cartDataResponse.json();
        this.updateCartCount(cartData.item_count);
      }
    } catch (e) {
      console.error("更新购物车UI失败:", e);
    }
  }

    /**
     * 更新购物车数量显示
     */
    updateCartCount(count) {
      let countBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      
      if (!countBubble) {
        countBubble = document.createElement('div');
        countBubble.className = 'cart-count-bubble';
        document.querySelector('#cart-icon-bubble')?.appendChild(countBubble);
      }
      
      countBubble.innerHTML = `
        <span aria-hidden="true">${count}</span>
        <span class="visually-hidden">${count} ${count === 1 ? 'item' : 'items'}</span>
      `;
    }
  }

  customElements.define('multi-add-cart-button', MultiAddCartButton);
}

